import { useCounterCustomerChargeMaintenanceTracked } from "presentation/store/CounterCustomerCharge/CounterCustomerChargeMaintenanceProvider";
import { useCallback, useMemo } from "react";
import { Loader, SliderPanel } from "veronica-ui-component/dist/component/core";
import CounterCustomerChargeDetailPanelTitleBar from "./CounterCustomerChargeDetailPanelTitleBar";
import CounterCustomerChargeTablePanel from "./CounterCustomerChargeTablePanel";
// import PaymentModeAndAdditionInfoComp from "./PaymentMode/PaymentModeAndAdditionInfoComp";
import AdditionalChargePanel from "./RightPanel/AdditionalChargePanel";
import AdjustmentPanel from "./RightPanel/AdjustmentPanel";
import ExtensionPaymentPanel from "./RightPanel/ExtensionPaymentPanel";
import StuffingPanel from "./RightPanel/StuffingPanel";
import SuppleWaiverPanel from "./RightPanel/SuppleWaiverPanel";
import UpdateAccTerminalPanel from "./RightPanel/UpdateAccTerminalPanel";
import UpdateAgentDeliveryDatePanel from "./RightPanel/UpdateAgentDeliveryDatePanel";
import UpdateBillToCompanyPanel from "./RightPanel/UpdateBillToCompanyPanel";
import UpdateChargeOnCompanyPanel from "./RightPanel/UpdateChargeOnCompanyPanel";
import UpdateChargeQtyPanel from "./RightPanel/UpdateChargeQtyPanel";
import UpdateExtraLaborPanel from "./RightPanel/UpdateExtraLaborPanel";
import UpdateInvoiceInfoPanel from "./RightPanel/UpdateInvoiceInfoPanel";
import UpdatePaidThroughDatePanel from "./RightPanel/UpdatePaidThroughDatePanel";
import UpdateWaiverReasonCodePanel from "./RightPanel/UpdateWaiverReasonCodePanel";
import PaymentModeAndAdditionInfoContent from "./PaymentMode/PaymentModeAndAdditionInfoContent";

const CounterCustomerChargeMaintenance: React.FC = () => {

    const [counterCustomerChargeState] = useCounterCustomerChargeMaintenanceTracked();
    // const messageBarVM = useMessageBarVM();
    const { isLoading, isShowAdditionalChargePanel, isShowWaiverReasonCodePanel, isShowBillToCompanyPanel, isShowChargeOnCompanyPanel,
        isShowInvoiceInfoPanel, isShowPaidThroughDatePanel, isShowSuppleWaiverPanel, isShowPaymentModePanel, isShowAdjustmentPanel, isShowChargeQtyPanel,
        isShowExtraLaborPanel, isShowAccTerminalPanel, isShowStuffingPanel, isShowAgentDeliveryDatePanel, isShowExtensionPaymentPanel } = counterCustomerChargeState;

    const isShowRightPanel = useCallback(() => {
        if (isShowAdditionalChargePanel || isShowPaymentModePanel || isShowBillToCompanyPanel || isShowChargeOnCompanyPanel
            || isShowInvoiceInfoPanel || isShowPaidThroughDatePanel || isShowWaiverReasonCodePanel
            || isShowSuppleWaiverPanel || isShowAdjustmentPanel || isShowChargeQtyPanel || isShowExtraLaborPanel
            || isShowAccTerminalPanel || isShowStuffingPanel || isShowAgentDeliveryDatePanel || isShowExtensionPaymentPanel) {
            return true;
        } else {
            return false;
        }
    }, [isShowAdditionalChargePanel, isShowPaymentModePanel, isShowBillToCompanyPanel, isShowChargeOnCompanyPanel,
        isShowInvoiceInfoPanel, isShowPaidThroughDatePanel, isShowWaiverReasonCodePanel, isShowSuppleWaiverPanel,
        isShowAdjustmentPanel, isShowChargeQtyPanel, isShowExtraLaborPanel, isShowAccTerminalPanel, isShowStuffingPanel, isShowAgentDeliveryDatePanel, isShowExtensionPaymentPanel]);

    const calculateSectionWidth = useCallback(() => {
        if (!isShowRightPanel()) {
            return {
                leftSectionWidth: "100%",
                rightSectionWidth: "0%"
            };
        } else if (isShowAdditionalChargePanel) {
            return {
                leftSectionWidth: "25%",
                rightSectionWidth: "75%"
            };
        } else if (isShowPaymentModePanel) {
            return {
                leftSectionWidth: "0%",
                rightSectionWidth: "100%"
            };
        } else if (isShowPaidThroughDatePanel || isShowAgentDeliveryDatePanel) {
            return {
                leftSectionWidth: "75%",
                rightSectionWidth: "25%"
            };
        } else if (isShowExtensionPaymentPanel) {
            return {
                leftSectionWidth: "65%",
                rightSectionWidth: "35%"
            };
        } else {
            return {
                leftSectionWidth: "80%",
                rightSectionWidth: "20%"
            };
        }
    }, [isShowRightPanel, isShowAdditionalChargePanel, isShowPaymentModePanel, isShowPaidThroughDatePanel, isShowAgentDeliveryDatePanel, isShowExtensionPaymentPanel]);

    const rightPanel = useMemo(() => {
        if (isShowAdditionalChargePanel) {
            return <AdditionalChargePanel />
        } else if (isShowPaymentModePanel) {
            return <PaymentModeAndAdditionInfoContent />
        } else if (isShowBillToCompanyPanel) {
            return <UpdateBillToCompanyPanel />
        } else if (isShowChargeOnCompanyPanel) {
            return <UpdateChargeOnCompanyPanel />
        } else if (isShowInvoiceInfoPanel) {
            return <UpdateInvoiceInfoPanel />
        } else if (isShowPaidThroughDatePanel) {
            return <UpdatePaidThroughDatePanel />
        } else if (isShowWaiverReasonCodePanel) {
            return <UpdateWaiverReasonCodePanel />
        } else if (isShowSuppleWaiverPanel) {
            return <SuppleWaiverPanel />
        } else if (isShowAdjustmentPanel) {
            return <AdjustmentPanel />
        } else if (isShowChargeQtyPanel) {
            return <UpdateChargeQtyPanel />
        } else if (isShowExtraLaborPanel) {
            return <UpdateExtraLaborPanel />
        } else if (isShowAccTerminalPanel) {
            return <UpdateAccTerminalPanel />
        } else if (isShowStuffingPanel) {
            return <StuffingPanel />
        } else if (isShowAgentDeliveryDatePanel) {
            return <UpdateAgentDeliveryDatePanel />
        } else if (isShowExtensionPaymentPanel) {
            return <ExtensionPaymentPanel />
        } else {
            return <></>;
        }
    }, [isShowAdditionalChargePanel, isShowPaymentModePanel, isShowBillToCompanyPanel, isShowChargeOnCompanyPanel, isShowInvoiceInfoPanel, isShowPaidThroughDatePanel, isShowWaiverReasonCodePanel, isShowSuppleWaiverPanel, isShowAdjustmentPanel, isShowChargeQtyPanel, isShowExtraLaborPanel, isShowAccTerminalPanel, isShowStuffingPanel, isShowAgentDeliveryDatePanel, isShowExtensionPaymentPanel]);

    const memoSliderPanel = useMemo(() => {
        return <SliderPanel
            isOpen={isShowRightPanel()}
            draggable={true}
            leftSectionWidth={calculateSectionWidth().leftSectionWidth}
            rightSectionWidth={calculateSectionWidth().rightSectionWidth}
            rightChildren={rightPanel}
            leftChildren={<CounterCustomerChargeTablePanel />}
        />
    }, [isShowRightPanel, calculateSectionWidth, rightPanel]);


    return <>
        {isLoading && <Loader Indicator="Spinner" size="Medium" />}

        <div className={`main-comp-wrapper im-hide-side-form-draggable`}>
            {!isShowPaymentModePanel && (< CounterCustomerChargeDetailPanelTitleBar />)}
            {memoSliderPanel}
        </div>
        {/* {isShowPaymentModePanel && <PaymentModeAndAdditionInfoComp />} */}
    </>
}

export default CounterCustomerChargeMaintenance;